module.exports = __webpack_public_path__ + "media/images/footer/pl_rp-a8092f598a14e3948c5f26f8fc6f14a8.svg";